import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { CheckCircle2 } from 'lucide-react';
const NAMES = ['María', 'Carlos', 'Laura', 'Ana', 'José', 'Sofía', 'Diego', 'Valentina', 'Juan', 'Camila', 'Roberto', 'Patricia', 'Fernando', 'Isabel', 'Miguel', 'Carmen'];
const CITIES = [
// América Latina
'Buenos Aires', 'Córdoba', 'Rosario', 'Mendoza', 'Santiago', 'Valparaíso', 'Concepción', 'Lima', 'Arequipa', 'Cusco', 'Bogotá', 'Medellín', 'Cali', 'Cartagena', 'Ciudad de México', 'Guadalajara', 'Monterrey', 'Puebla', 'Quito', 'Guayaquil', 'Caracas', 'Maracaibo', 'La Paz', 'Santa Cruz', 'Asunción', 'Montevideo', 'San José', 'Panamá', 'San Salvador', 'Tegucigalpa', 'Managua', 'Guatemala', 'Santo Domingo', 'San Juan', 'La Habana',
// España
'Madrid', 'Barcelona', 'Valencia', 'Sevilla', 'Zaragoza', 'Málaga', 'Murcia', 'Bilbao', 'Alicante', 'Granada',
// Estados Unidos (ciudades hispanas)
'Miami', 'Los Ángeles', 'Nueva York', 'Houston', 'San Antonio', 'Phoenix', 'San Diego', 'Dallas', 'Chicago'];
export function PurchaseNotification() {
  const [isVisible, setIsVisible] = useState(false);
  const [currentData, setCurrentData] = useState({
    name: '',
    city: ''
  });
  useEffect(() => {
    // Initial delay
    const initialTimeout = setTimeout(() => {
      showNotification();
    }, 5000);
    const showNotification = () => {
      const randomName = NAMES[Math.floor(Math.random() * NAMES.length)];
      const randomCity = CITIES[Math.floor(Math.random() * CITIES.length)];
      setCurrentData({
        name: randomName,
        city: randomCity
      });
      setIsVisible(true);
      // Hide after 4 seconds
      setTimeout(() => {
        setIsVisible(false);
        // Schedule next show
        const nextDelay = Math.random() * (15000 - 8000) + 8000; // 8-15 seconds
        setTimeout(showNotification, nextDelay);
      }, 4000);
    };
    return () => clearTimeout(initialTimeout);
  }, []);
  return <AnimatePresence data-id="element-191">
      {isVisible && <motion.div initial={{
      x: 100,
      opacity: 0
    }} animate={{
      x: 0,
      opacity: 1
    }} exit={{
      x: 100,
      opacity: 0
    }} className="fixed bottom-4 right-4 z-50 bg-white rounded-lg shadow-2xl p-4 flex items-center gap-4 max-w-xs border-l-4 border-[#FF6B35]" data-id="element-192">
          <div className="bg-green-100 p-2 rounded-full" data-id="element-193">
            <CheckCircle2 className="w-6 h-6 text-green-600" data-id="element-194" />
          </div>
          <div data-id="element-195">
            <p className="font-bold text-gray-900 text-sm" data-id="element-196">
              {currentData.name} de {currentData.city}
            </p>
            <p className="text-xs text-gray-600" data-id="element-197">
              acaba de comprar el Megapack
            </p>
            <p className="text-[10px] text-gray-400 mt-1" data-id="element-198">Hace unos segundos</p>
          </div>
        </motion.div>}
    </AnimatePresence>;
}